const CREDIT_CARD_TYPES = {
    UNKNOWN: {
        typeId: '',
        cvvMask: '####',
        displayName: '',
        iconSlug: '',
        numberMask: '#### #### #### ####'
    },
    AMEX: {
        typeId: 'AmericanExpress',
        cvvMask: '####',
        displayName: 'American Express',
        iconSlug: '/payment-method_amex.svg',
        numberMask: '#### ###### #####'
    },
    DISCOVER: {
        typeId: 'Discover',
        cvvMask: '###',
        displayName: 'Discover',
        iconSlug: '/payment-method_discover.svg',
        numberMask: '#### #### #### ####'
    },
    MASTERCARD: {
        typeId: 'MasterCard',
        cvvMask: '###',
        displayName: 'MasterCard',
        iconSlug: '/payment-method_mc.svg',
        numberMask: '#### #### #### ####'
    },
    VISA: {
        typeId: 'Visa',
        cvvMask: '###',
        displayName: 'Visa',
        iconSlug: '/payment-method_visa.svg',
        numberMask: '#### #### #### ####'
    }
}

module.exports = { CREDIT_CARD_TYPES }
